module.exports = __webpack_public_path__ + "img/photo-11.5eb5201a.jpg";